import { classicBusinessProjectViewNotFoundRoute } from '@jira/router-routes__business-view-not-found-routes/src/classicBusinessProjectViewNotFoundRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { projectViewNotFoundPageEntrypoint } from '@jira/spa-apps__error-pages-project-view-not-found/src/projectViewNotFoundPageEntrypoint.entrypoint.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const classicBusinessProjectViewNotFoundRouteEntry: Route = createEntry(
	classicBusinessProjectViewNotFoundRoute,
	() => ({
		group: 'classic-business',
		layout: businessProjectLayout,
		skeleton: ThemedLazySkeleton,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: getProjectViewResources(),
		entryPoint: () => projectViewNotFoundPageEntrypoint,

		supportsProjectTheme: 'full',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
